import type {
    IInputDatasetCursorPage,
    IInputDatasetResponse,
    IInputDatasetSearchParams,
} from '@escloud/types';

import type { ApiClient } from './api-client';

/**
 * Re-exported under the legacy local name so existing call sites (the
 * use-datasets hooks, picker dialog) keep compiling. The single source
 * of truth is `IInputDatasetSearchParams` in `@escloud/types`.
 */
export type SearchDatasetsParams = IInputDatasetSearchParams;

/**
 * User-facing dataset search & retrieval client.
 *
 * `getPreview` returns an `ArrayBuffer` (not JSON) — TanStack Query
 * caches it like any other query result, so re-selecting a dataset in
 * the picker is instant after the first fetch.
 */
export class InputDatasetsService {
    constructor(private api: ApiClient) {}

    searchDatasets(params: SearchDatasetsParams): Promise<IInputDatasetCursorPage> {
        const usp = new URLSearchParams();
        for (const [k, v] of Object.entries(params)) {
            if (v === undefined || v === null || v === '') continue;
            usp.append(k, String(v));
        }
        const qs = usp.toString();
        return this.api.get<IInputDatasetCursorPage>(qs ? `/datasets?${qs}` : '/datasets');
    }

    getDataset(id: string): Promise<IInputDatasetResponse> {
        return this.api.get<IInputDatasetResponse>(`/datasets/${id}`);
    }

    getPreview(id: string): Promise<ArrayBuffer> {
        return this.api.getBinary(`/datasets/${id}/preview`);
    }
}
